import React from "react"
import clsx from "clsx"

import { useTranslation } from "react-i18next"

import { Modal } from "components/modals/Modal"

type Props = {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  loading?: boolean
  title?: string
  description?: React.ReactNode
  confirmText?: string
}

export const ModalConfirmAffiliateAction = ({ open, onClose, onConfirm, loading, title, description, confirmText }: Props) => {
  const { t } = useTranslation("translation", { useSuspense: false })

  const resolvedTitle = title ?? t("affiliate.confirmTitle")
  const resolvedDescription = description ?? t("affiliate.confirmDescription")
  const resolvedConfirmText = confirmText ?? t("common.confirm")

  return (
    <Modal open={open} handler={onClose}>
      <div className="w-[92vw] max-w-lg rounded-2xl border border-[rgba(0,0,0,0.08)] dark:border-[rgba(255,255,255,0.10)] bg-white dark:bg-[#0C0C1A] shadow-xl">
        <div className="p-5 sm:p-6">
          <div className="text-lg font-semibold">{resolvedTitle}</div>
          <div className="mt-2 text-sm opacity-70">{resolvedDescription}</div>

          <div className="mt-6 flex items-center justify-end gap-2">
            <button type="button" className={clsx("btn btn-ghost", { "btn-disabled": loading })} onClick={onClose} disabled={loading}>
              {t("common.cancel")}
            </button>

            <button type="button" className={clsx("btn btn-primary", { "btn-disabled": loading })} onClick={onConfirm} disabled={loading}>
              {loading ? <span className="loading loading-spinner loading-xs" /> : null}
              {resolvedConfirmText}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
